export const FE_VERSION = '2.1.4';